import {
  ArrowBack as ArrowBackIcon,
  Refresh as RefreshIcon,
} from "@mui/icons-material";
import { Box, Typography, IconButton, Breadcrumbs, Link } from "@mui/material";
import React from "react";
import { useParams, useNavigate } from "react-router";

import { SleepChart } from "components/features/patient/detail";
import { DashboardLayout } from "components/layouts";
import { EPath } from "constants/path";

const SleepHistoryPage: React.FC = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const navigate = useNavigate();

  if (!patientId)
    return (
      <Box sx={{ p: 2 }}>
        <Typography>No patient found</Typography>
      </Box>
    );

  return (
    <DashboardLayout title="Sleep">
      <Box sx={{ p: 2 }}>
        {/* Breadcrumbs */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Breadcrumbs>
            <Link
              color="inherit"
              component="button"
              onClick={() => navigate(EPath.HOME)}
            >
              Dashboard
            </Link>
            <Link
              color="inherit"
              component="button"
              onClick={() => navigate(EPath.PATIENT_MANAGEMENT)}
            >
              Patient Management
            </Link>
            <Link
              color="inherit"
              component="button"
              onClick={() =>
                navigate(EPath.PATIENT_DETAIL.replace(":patientId", patientId))
              }
            >
              Patient Details
            </Link>
            <Typography color="text.primary">Sleep</Typography>
          </Breadcrumbs>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton
              onClick={() => navigate(-1)}
              size="small"
              sx={{ color: "text.secondary" }}
            >
              <ArrowBackIcon />
            </IconButton>
            <IconButton
              onClick={() => window.location.reload()}
              size="small"
              sx={{ color: "text.secondary" }}
            >
              <RefreshIcon />
            </IconButton>
          </Box>
        </Box>

        {/* Sleep Chart */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
          }}
        >
          <SleepChart patientId={patientId} />
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default SleepHistoryPage;
